import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" fill="none" viewBox="0 0 26 27">
      <circle cx="13" cy="13.5" r="12" stroke={props.fill || '#1D252D'} strokeDasharray="4 6" strokeLinecap="round" strokeOpacity="0.5" strokeWidth="2"></circle>
    </svg>;
}
export default Icon;